module.exports = __webpack_public_path__ + "assets/54eb2d156237bb93939e3e0f0f73b065.png";